import { ref } from 'vue'

const currentUser = ref(window.componentData.currentUser)

export const can = (ability, model = null) => {
  if (guest()) {
    return false
  }
  if (!currentUser.value.can[ability]) {
    return false
  }
  if (!model) {
    if (currentUser.value.can[ability] === true) {
      return true
    }
    return false
  }
  if (model.id) {
    model = model.id
  }
  return currentUser.value.can[ability].some(allowedModel => allowedModel === model)
}

export const cannot = (ability, model = null) => {
  return !can(ability, model)
}

export const updateAbilities = (abilities) => {
  return currentUser.value.can = {
    ...currentUser.value.can,
    ...abilities,
  }
}
export const auth = () => {
  return !!currentUser.value
}
export const guest = () => {
  return !currentUser.value
}
export const fullName = (user) => {
  return `${user.first_name} ${user.last_name}`
}
export const userInitials = (user) => {
  const firstInitial = user.first_name.charAt(0)
  const lastNameCapitals = user.last_name.replace(/[a-z]/g, '').replaceAll(/\s/g, '')
  const lastInitial = lastNameCapitals.charAt(0)

  return `${firstInitial}${lastInitial}`
}

export default {
  data: () => ({
    currentUser,
  }),
  methods: {
    $can: can,
    $cannot: cannot,
    $auth: auth,
    $guest: guest,
    $fullName: fullName,
    $userInitials: userInitials,
  },
}
